export enum TabsDetalheParceirosRoutes {
  DadosDoParceiro = "dados do parceiro",
  HorarioDeFuncionamento = "horário de funcionamento",
  Fotos = "fotos",
  Endereco = "endereço",
  Editar = 'editar',
}

export const TabsDetalheParceiros: {
  label: string;
  route: TabsDetalheParceirosRoutes;
  permissions: string[];
}[] = [
  {
    label: "Cadastrar Parceiro",
    route: TabsDetalheParceirosRoutes.DadosDoParceiro,
    permissions: [],
  },
  {
    label: "Horário de Funcionamento",
    route: TabsDetalheParceirosRoutes.HorarioDeFuncionamento,
    permissions: [],
  },
  {
    label: "Fotos",
    route: TabsDetalheParceirosRoutes.Fotos,
    permissions: [],
  },
  {
    label: "Endereço",
    route: TabsDetalheParceirosRoutes.Endereco,
    permissions: [],
  },
];
